module.exports = __webpack_public_path__ + "static/media/dshub.1cd349fa.png";